module.exports = __webpack_public_path__ + "img/hero-slide-1.cec146ca.svg";